const INDEX_ITEMS = [
  { title: '娱乐圈吃瓜专区', desc: '艺人动态、影视爆料、综艺内幕一网打尽', count: '1,256条', icon: 'ri-movie-line' },
  { title: '科技互联网内幕', desc: '大厂动态、产品缺陷、行业潜规则深度揭秘', count: '892条', icon: 'ri-smartphone-line' },
  { title: '消费避坑指南', desc: '食品安全、购物陷阱、服务纠纷真实曝光', count: '763条', icon: 'ri-shopping-bag-line' },
  { title: '职场生存实录', desc: '招聘黑话、裁员内幕、职场PUA匿名分享', count: '645条', icon: 'ri-briefcase-line' },
  { title: '房产楼市观察', desc: '楼盘质量、政策解读、业主维权集中曝光', count: '521条', icon: 'ri-building-line' },
  { title: '教育培训揭秘', desc: '机构跑路、师资造假、课程骗局全面起底', count: '438条', icon: 'ri-book-open-line' },
  { title: '交通出行曝光', desc: '网约车黑幕、航空纠纷、打车乱象集中营', count: '389条', icon: 'ri-car-line' },
  { title: '金融理财警示', desc: '平台爆雷、理财骗局、保险套路防坑指南', count: '312条', icon: 'ri-bank-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按领域浏览你最关心的爆料内容
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#"
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-1.5 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{item.desc}</p>
              <span className="text-[11px] text-primary-500 font-medium">{item.count} 爆料</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}